module.exports = __webpack_public_path__ + "static/img/mosquito-surveillance.238125f.svg";